import {
  learningStartingPoint,
  LearningStartingPoint,
} from "@chesshotel/types";
import { refreshLearning } from "./learningEvents";

const key = "chesshotel:learning-starting-point:v1";
let fallback: LearningStartingPoint | undefined;
let persisted = true;
export function getGuestStartingPoint() {
  if (typeof window === "undefined") return undefined;
  if (!persisted) return fallback;
  try {
    return learningStartingPoint(window.localStorage.getItem(key));
  } catch {
    persisted = false;
    return fallback;
  }
}
export function setGuestStartingPoint(value: LearningStartingPoint) {
  fallback = value;
  try {
    window.localStorage.setItem(key, value);
    persisted = true;
  } catch {
    persisted = false;
  }
  refreshLearning();
}
export const guestStartingPointPersisted = () => persisted;

const dismissedKey = "chesshotel:learning-placement-dismissed:v1";
let dismissedFallback = false;
export function guestPlacementDismissed() {
  try {
    return (
      dismissedFallback || window.localStorage.getItem(dismissedKey) === "1"
    );
  } catch {
    return dismissedFallback;
  }
}
export function dismissGuestPlacement() {
  dismissedFallback = true;
  try {
    window.localStorage.setItem(dismissedKey, "1");
  } catch {
    /* Session-only fallback. */
  }
}
